var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"new-bank-account"}},[_c('bank-account-form',{attrs:{"isDark":true,"inDialog":true,"mode":_vm.mode,"record":_vm.record,"errors":_vm.errors},on:{"createBankAccount":_vm.createBankAccount,"cancel":_vm.onCancel}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af98cbfa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewTransaction/NewBankAccountView.vue
// module id = null
// module chunks = 